import React, { useContext } from "react";
import "./Hero.css";
import thumbsup from "../Assets/thumbsup.png";
import right_arrow from "../Assets/right_arrow.png";
import hero from "../Assets/hero.png";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

import { ShopContext } from "../../Context/ShopContext";

const mainURL = process.env.REACT_APP_API_BASE_URL;

const Hero = () => {
  const { all_products } = useContext(ShopContext);

  if (!all_products || all_products.length === 0) {
    return (
      <div className="hero">
        <div className="hero-left">
          <h2>NEW ARRIVALS ONLY</h2>

          <div>
            <div className="hero-hand-icon">
              <p>new</p>
              <img src={thumbsup} alt="thumbsup" />
            </div>
            <p>collections</p>
            <p>for everyone</p>
          </div>

          <div className="hero-latest-btn">
            <div>Latest Collection</div>
            <img src={right_arrow} alt="arrow" />
          </div>
        </div>

        <div className="hero-right">
          <h2>Loading...</h2>
        </div>
      </div>
    );
  }

  return (
    <div className="hero">
      <div className="hero-left">
        <h2>NEW ARRIVALS ONLY</h2>

        <div>
          <div className="hero-hand-icon">
            <p>new</p>
            <img src={thumbsup} alt="thumbsup" />
          </div>

          <p>collections</p>
          <p>for everyone</p>
        </div>

        <div className="hero-latest-btn">
          <div>Latest Collection</div>
          <img src={right_arrow} alt="arrow" />
        </div>
      </div>

      <div className="hero-right">
        <Swiper
          modules={[Navigation, Autoplay]}
          navigation
          className="mySwiper"
          loop={all_products.length > 1}
          autoplay={{
            delay: 3000, // 3 seconds ke baad next slide
            disableOnInteraction: false,
          }}
          speed={800}
        >
          {all_products.map((product, index) => {
            const imageUrl =
              product.product_images?.length > 0
                ? `${mainURL}/${product.product_images[0].image_path}`
                : hero;

            return (
              <SwiperSlide
                key={product.item_id || product.product_id || index}
              >
                <div className="hero-product-card">
                  <img
                    src={imageUrl}
                    alt={product.item_name || "Product"}
                    className="hero-image"
                  />

                  <div className="hero-product-info">
                    <h3>{product.item_name}</h3>

                    {product.product_cost[0].selling_price && (
                      <h2>₹{product.product_cost[0].selling_price}</h2>
                    )}

                    {/* <button>Shop Now</button> */}
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </div>
  );
};

export default Hero;
